import React from 'react';
import styles from './PaymentInvoice.module.css';

const FilterBar = ({
  searchQuery,
  onSearchChange,
  typeFilter,
  onTypeChange,
  dateFilter,
  onDateChange,
  showRefundsOnly,
  onRefundsOnlyChange,
  onApply,
}) => (
  <div className={`card ${styles.card} ${styles.filterBar}`}>
    <input
      className={`input ${styles.searchInput}`}
      placeholder="🔍  Search order number..."
      value={searchQuery}
      onChange={onSearchChange}
    />
    <div className="select">
      <select
        className={styles.filterSelect}
        value={typeFilter}
        onChange={onTypeChange}
      >
        <option value="all">All Types</option>
        <option value="Delivery">🚴 Delivery</option>
        <option value="Pickup">🥡 Pickup</option>
        <option value="Dine-in">🍽 Dine-in</option>
        {/* <option value="Booking">🗓 Booking</option> */}
      </select>
    </div>
    {/* {onDateChange && (
      <div className="select">
        <select
          className={styles.filterSelect}
          value={dateFilter || ''}
          onChange={onDateChange}
        >
          <option value="">All Dates</option>
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="last7">Last 7 days</option>
          <option value="last30">Last 30 days</option>
        </select>
      </div>
    )} */}
    {onRefundsOnlyChange && (
      <label className={styles.checkLabel}>
        <input
          type="checkbox"
          checked={showRefundsOnly || false}
          onChange={onRefundsOnlyChange}
        />
        Show refunds only
      </label>
    )}
    {onApply && (
      <button
        className={`button ${styles.btn} ${styles.btnPrimary} ${styles.btnSm}`}
        onClick={onApply}
      >
        Apply
      </button>
    )}
    {/* <button
      className={`button ${styles.btn} ${styles.btnSecondary} ${styles.btnSm}`}
    >
      ⬇ Export Orders
    </button> */}
  </div>
);

export default FilterBar;
